import React, { Component } from 'react';
import { Table, Tabs } from 'antd';
import '../style.scss';

const { TabPane } = Tabs;

const EncodedDataImage = ({ icon }) => {
  if (icon.coin === 'ETH') {
    return <img alt={icon.coin} src={`${icon.icon_image}`} width="30px" />;
  }
  return <img alt={icon.coin} src={`${icon.icon_image}`} width="40px" />;
};

class MobileDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      columns: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.mobileSettingDataTable,
      columns: [
        {
          title: 'Coin',
          width: 120,
          dataIndex: 'coin',
          key: 'coin',
          fixed: 'left',
          render: (value) => (
            <div className="coin">
              <div className="image-left"><EncodedDataImage icon={nextProps.mobileSettingDataTable.coins[`${value}`]} /></div>
              <div className="content-right">
                <p>{value}</p>
                <p>{nextProps.mobileSettingDataTable.coins[`${value}`].name}</p>
              </div>
            </div>
          ),
        },
        {
          title: 'Latest Price',
          width: 60,
          dataIndex: 'last_price',
          key: 'last_price',
          align: 'left',
        },
        {
          title: '24H Change',
          width: 60,
          dataIndex: 'change',
          key: 'change',
          align: 'center',
        },
        {
          title: '24H High',
          dataIndex: 'high',
          key: 'high',
          width: 60,
          align: 'center',
        },
        {
          title: '24H Low',
          dataIndex: 'low',
          key: 'low',
          width: 60,
          align: 'center',
        },
        {
          title: '24H Volume',
          dataIndex: 'volume',
          key: 'volume',
          width: 60,
          align: 'right',
        },
      ],

    });
  }

  render() {
    const { columns } = this.state;
    function callback(key) {
    }

    return (
      <Tabs
        onChange={callback}
        type="card"
        style={{ textAlign: 'left' }}
        tabBarGutter={5}
        tabBarStyle={{

			  border: 'none',
        }}
      >
        {
					window._.map(this.props.mobileSettingDataTable.currencyMarkets, (markets, currency) => (
  <TabPane style={{ background: '#fff' }} tab={`${currency}`.toUpperCase()} key={currency}>
    <Table columns={columns} dataSource={[...markets || []]} scroll={{ x: 600, y: 300 }} />
  </TabPane>
					))
				}
      </Tabs>
    );
  }
}

export default MobileDataTable;
